import gql from 'graphql-tag';

export const GET_SERVICE_PROVIDER_BY_CLIENT_CODE = gql`
  query GetServiceProviderByClientCode($clientCode: String!) {
    __typename
    getServiceProviderByClientCode(clientCode: $clientCode) {
      __typename
      ... on GetServiceProviderByClientCode {
        message
        version
        serviceProviderName
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const GET_CLIENT_ACCOUNT = gql`
  query GetClientAccount {
    getClientAccount {
      ... on GetClientAccount {
        message
        version
        account {
          id
          accountType
          settings {
            notificationMethod
            notificationChatMessages
            notificationJobReminders
            notificationJobStatus
            notificationMarketing
            notificationAnnoucements
            dashboardAdvancedView
            doNotShareInformation
          }
          referredBy
          companyName
          website
          companyEmail
          companyPhone
          billingInfo {
            companyName
            contactName
            address1
            address2
            city
            state
            zip
            country
          }
          timeZone
          availability {
            dayTimeSlots {
              day
              startTime
              endTime
            }
            exceptionDates {
              startDate
              endDate
              annual
            }
            exceptionMonthJan
            exceptionMonthFeb
            exceptionMonthMar
            exceptionMonthApr
            exceptionMonthMay
            exceptionMonthJun
            exceptionMonthJul
            exceptionMonthAug
            exceptionMonthSep
            exceptionMonthOct
            exceptionMonthNov
            exceptionMonthDec
            exceptionWinter
            exceptionSpring
            exceptionSummer
            exceptionFall
          }
          createdAt
          updatedAt
          isArchived
          properties {
            id
            account_id
            client_account_id
            name
            contactName
            contactPhone
            contactEmail
            address1
            address2
            city
            state
            zip
            country
            photoUrl
            timeZone
            availability {
              dayTimeSlots {
                day
                startTime
                endTime
              }
              exceptionDates {
                startDate
                endDate
                annual
              }
              exceptionMonthJan
              exceptionMonthFeb
              exceptionMonthMar
              exceptionMonthApr
              exceptionMonthMay
              exceptionMonthJun
              exceptionMonthJul
              exceptionMonthAug
              exceptionMonthSep
              exceptionMonthOct
              exceptionMonthNov
              exceptionMonthDec
              exceptionWinter
              exceptionSpring
              exceptionSummer
              exceptionFall
            }
            propertyType
            createdAt
            updatedAt
            isArchived
          }
          serviceCategories
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const GET_CLIENT_ACCOUNT_CRISP_IDENTITY = gql`
  query GetClientAccountCrispIdentity {
    getClientAccount {
      ... on GetClientAccount {
        account {
          id
          companyName
        }
      }
    }
  }
`;
